import React, { useEffect, useState, useCallback } from "react";

import { Link, useParams, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setLoading, setModule } from "../../store/actions/commonAction";
import CommonDataService from "../../services/common";
import { parseNumber } from "../../helpers/common";

import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import TextField from "@mui/material/TextField";

import Button from "@mui/material/Button";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Divider from "@mui/material/Divider";
import SaveIcon from "@mui/icons-material/Save";

import MessageDialog from "../MessageDialog";
import http from "../../http";

export default function AddFeaturedListing({ placeholder }) {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	let { id } = useParams();

	const loading = useSelector((state) => state.commonReducer.loading);

	const [message, setMessage] = useState("");
	const [error, setError] = useState(false);

	const [listingId, setListingId] = useState("");
	const [sortOrder, setSortOrder] = useState("");

	const LoadSelect = useCallback(() => {
		dispatch(setLoading(true));
		dispatch(setModule("Featured Listing"));

		if (typeof id !== "undefined") {
			CommonDataService.getFeaturedListingById(id)
				.then((res) => {
					setListingId(res.data.Row.listing_id);
					setSortOrder(res.data.Row.sort_order);

					dispatch(setLoading(false));
				})
				.catch(function (error) {
					setMessage(error.response.data.message);
					setError(true);
					dispatch(setLoading(false));
				});
		} else {
			dispatch(setLoading(false));
		}
	}, [dispatch, id]);

	useEffect(() => {
		LoadSelect();
	}, [LoadSelect]);

	const handleSubmit = (event) => {
		event.preventDefault();
		dispatch(setLoading(true));

		if (typeof id === "undefined") {
			id = 0;
		}

		const data = {
			id: parseNumber(id),
			listing_id: parseNumber(listingId),
			sort_order: parseNumber(sortOrder),
		};

		http
			.post("/featured_listing/save", data)
			.then((res) => {
				dispatch(setLoading(false));
				navigate("/featured_listing" + window.location.search);
			})
			.catch(function (error) {
				setMessage(error.response.data.message);
				setError(true);
				dispatch(setLoading(false));
			});
	};

	return (
		<Grid container spacing={3}>
			<Grid item xs={12}>
				<MessageDialog show={error} message={message} dialogClose={setError} />

				<Paper
					sx={{
						p: 2,
						display: "flex",
						flexDirection: "column",
					}}
				>
					<Box component="form" onSubmit={(e) => handleSubmit(e)}>
						<Typography variant="h5">Featured Listing Form</Typography>

						<Grid container spacing={3}>
							<Grid item xs={12} sm={6}>
								<TextField
									required
									label="Listing ID"
									id="listingId"
									name="listingId"
									value={listingId}
									fullWidth
									variant="standard"
									onChange={(e) => setListingId(e.target.value)}
								/>
							</Grid>

							<Grid item xs={12} sm={6}>
								<TextField
									label="Order"
									id="sortOrder"
									name="sortOrder"
									value={sortOrder}
									fullWidth
									variant="standard"
									onChange={(e) => setSortOrder(e.target.value)}
								/>
							</Grid>

							<Grid item xs={12} sm={12}>
								<Divider />
							</Grid>

							<Grid item xs={12} sm={12}>
								<Button
									variant="contained"
									component={Link}
									to={"/featured_listing" + window.location.search}
									startIcon={<ArrowBackIcon />}
									sx={{ mr: 1 }}
								>
									Cancel
								</Button>
								<Button
									type="submit"
									variant="contained"
									disabled={loading}
									startIcon={<SaveIcon />}
								>
									{loading && (
										<span>
											<span className="spinner-border spinner-border-sm"></span>
											&nbsp;
										</span>
									)}
									<span> {loading ? "Please Wait" : "Save"}</span>
								</Button>
							</Grid>
						</Grid>
					</Box>
				</Paper>
			</Grid>
		</Grid>
	);
}
